const Style = {
    container: 'flex flex-col gap-2',
    btn: 'w-full justify-center',
    archive: 'w-full justify-center text-error hover:bg-error/10',
};

export default Style;
